export const unknownError = "Desculpe pelo transtorno. Houve um erro ao carregar página"

export const unLoggedIn = "Você não está logado no sistema. Faça login aqui"